import { ConfirmationModal } from 'modules/ui';
import DeleteApplicationModalView from 'modules/application/detail/configurations/basic/DeleteApplicationModal/DeleteApplicationModalView.html';
import { DeleteApplicationModalController } from 'modules/application/detail/configurations/basic/DeleteApplicationModal//DeleteApplicationModalController';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { removeSpecialCharacter } from 'modules/shared/validators/ApplicationNameValidation';
export class EditApplicationController {
    static $inject = ['LoadingService', 'ApplicationService2', 'ModalService', 'PermissionsService', 'ngToast', '$state', '$q', '$translate', 'application', 'ConfigurationsSegmentService', 'MessagingHubService', 'SharedToastsService', 'AiAgentService', 'MEDIA_PROFILE_FOR_AVATARS'];
    constructor(LoadingService, ApplicationService2, ModalService, PermissionsService, ngToast, $state, $q, $translate, application, ConfigurationsSegmentService, MessagingHubService, SharedToastsService, AiAgentService, MEDIA_PROFILE_FOR_AVATARS) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.ApplicationService2 = ApplicationService2;
        this.ModalService = ModalService;
        this.PermissionsService = PermissionsService;
        this.ngToast = ngToast;
        this.$state = $state;
        this.$q = $q;
        this.$translate = $translate;
        this.application = application;
        this.ConfigurationsSegmentService = ConfigurationsSegmentService;
        this.MessagingHubService = MessagingHubService;
        this.SharedToastsService = SharedToastsService;
        this.AiAgentService = AiAgentService;
        this.MEDIA_PROFILE_FOR_AVATARS = MEDIA_PROFILE_FOR_AVATARS;
        this.$onInit = () => { };
        //Initialize screen
        this.init();
    }
    async init() {
        this.application.image = this.application.imageUri;
        this.editingApplication = { ...this.application };
        this.hasPermission = await this.PermissionsService.hasPermissions('write');
        this.canDeleteBot = await this.checkCanDeleteBot();
        this.ConfigurationsSegmentService.setApplication(this.application);
        this.isAiAgent = await this.AiAgentService.checkAiAgentAsync();
        this.trackBasicsOpnened();
    }
    validateSpecialCharacter(inputValue, field) {
        const withoutSpecialCharacter = removeSpecialCharacter(inputValue);
        field === 'name' ? this.editingApplication.name = withoutSpecialCharacter : this.editingApplication.description = withoutSpecialCharacter;
    }
    async save() {
        this.applicationForm.$setPristine();
        this.LoadingService.startLoading();
        try {
            await this.uploadImage();
            const account = await this.MessagingHubService.sendCommand({
                method: 'get',
                uri: '/account',
            });
            const newAccount = {
                ...account,
                extras: {
                    ...account.extras,
                    description: this.editingApplication.description,
                },
                fullName: this.editingApplication.name,
                photoUri: this.editingApplication.imageUri,
            };
            await this.MessagingHubService.sendCommand({
                method: 'set',
                type: 'application/vnd.lime.account+json',
                uri: '/account',
                resource: newAccount,
            });
            this.trackChatbotEdited(this.objectsDifferentKeys(this.editingApplication, this.application));
            const successMessage = await this.$translate('utils.successMsg.8');
            this.ngToast.success(successMessage);
        }
        catch (err) {
            if (err?.config?.url.includes('/media')) {
                this.SharedToastsService.showUploadErrorToast(err.status);
            }
            else {
                const errorMessage = await this.$translate('utils.errorMsg.6');
                this.ngToast.danger(errorMessage);
            }
        }
        finally {
            this.$state.reload();
            this.LoadingService.stopLoading();
        }
    }
    async delete() {
        this.LoadingService.startLoading();
        try {
            // Delete application on Iris server
            this.application.messagingHubCommandWithDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
            await this.ApplicationService2.deleteAndRevokeApplication(this.application);
            const successMessage = await this.$translate('modules.application.detail.edit.deleteSuccessMessage');
            this.ngToast.success(successMessage);
            this.$state.go('auth.application.list');
            // Close the connection
            this.MessagingHubService.closeClient(this.application);
        }
        catch (err) {
            const errorMessage = await this.$translate('modules.application.detail.edit.deleteErrorMessage');
            this.ngToast.danger(errorMessage);
        }
        finally {
            this.trackOldChatbotDeleted();
            this.LoadingService.stopLoading();
        }
    }
    async openDeleteApplicationModal() {
        const deleteApplicationModal = await this.ModalService.showModal({
            template: DeleteApplicationModalView,
            controller: DeleteApplicationModalController,
            controllerAs: '$ctrl',
            inputs: {
                shortName: this.application.shortName,
            },
        });
        const confirmation = await deleteApplicationModal.close;
        if (confirmation) {
            await this.delete();
            this.trackChatbotDeleted();
        }
    }
    async openAdvancedSettingsModal($event) {
        $event.stopPropagation();
        const title = await this.$translate('utils.misc.warning');
        const body = await this.$translate('modules.application.detail.edit.advancedConfigurationModal');
        const confirm = await this.$translate('utils.forms.continue');
        const cancel = await this.$translate('utils.forms.cancel');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: title,
                class: 'bp-c-delete',
            },
            body: body,
            buttons: {
                confirm: {
                    text: confirm,
                },
                cancel: {
                    text: cancel,
                },
            },
        }));
        const confirmation = await modal.close;
        if (!confirmation) {
            return;
        }
        this.$state.go('auth.application.detail.configurations.advanced');
    }
    objectsDifferentKeys(primary, secondary) {
        return Object.keys(primary).filter((key) => {
            return primary[key] != secondary[key];
        });
    }
    async uploadImage() {
        if (!this.editingApplication.image ||
            this.editingApplication.image === this.editingApplication.imageUri) {
            return this.$q.resolve({});
        }
        const mediaUri = await this.ApplicationService2.uploadFile(this.editingApplication.image, { profile: this.MEDIA_PROFILE_FOR_AVATARS });
        this.editingApplication.imageUri = mediaUri;
    }
    checkCanDeleteBot() {
        return this.PermissionsService.hasPermissions('write', 'team');
    }
    // Segment
    trackBasicsOpnened() {
        this.ConfigurationsSegmentService.trackBasicsOpened();
    }
    trackChatbotEdited(type) {
        this.ConfigurationsSegmentService.trackChatbotEdited({
            Type: type,
        });
    }
    trackChatbotDeleted() {
        this.ConfigurationsSegmentService.trackChatbotDeleted();
    }
    // OldChatbotDeleted is an event created before ChatbotDeleted with the same semantic.
    // As it was already in use on mixpanel, so it was mantained to don't affect current metrics.
    trackOldChatbotDeleted() {
        this.ConfigurationsSegmentService.trackOldChatbotDeleted();
    }
}
EditApplicationController.$inject = ['LoadingService', 'ApplicationService2', 'ModalService', 'PermissionsService', 'ngToast', '$state', '$q', '$translate', 'application', 'ConfigurationsSegmentService', 'MessagingHubService', 'SharedToastsService', 'AiAgentService', 'MEDIA_PROFILE_FOR_AVATARS'];
